import React from "react";
import { trans, iosAndroidDetector } from "../../helpers/index";
import { withCookies } from "react-cookie";

const AppBox = (props) => {
  const platform = iosAndroidDetector();
  let beeline_app = null;

  if (props.config.hasOwnProperty("data")) {
    beeline_app = props.config.data.beeline_app;
  }

  if (
    props.cookies.get("appBoxHidden") ||
    platform === null ||
    beeline_app === null ||
    props.cookies.get("loginTokenB2b")
  ) {
    return "";
  }

  let prefix = "app_store_",
    drawStarsHook = (rating) => {
      rating = Number(rating);

      return [1, 2, 3, 4, 5].map((item, index) => {
        let w = rating >= item ? 100 : (rating - (item - 1)) * 100;

        return (
          <span
            className="app-box__rate-item app-box__rate-item--gray ver-top-box sprite"
            key={index}
          >
            <span
              className="app-box__rate-item app-box__rate-item--yellow ver-top-box sprite"
              style={{ width: w + "%" }}
            >
              {" "}
            </span>
          </span>
        );
      });
    };

  if (platform === "android") {
    prefix = "google_play_";
  }

  // Go to application if installed
  if (!props.parentState.appRedirect) {
    //setTimeout(() => { window.location = beeline_app[prefix + 'url']; }, 25);
    window.location = "Beeline://";
    props.updateParentState({ appRedirect: true });
  }

  return (
    <div className="app-box pr">
      <button
        className="app-box__close-btn sprite pa"
        type="button"
        onClick={() => {
          let d = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);

          props.cookies.set("appBoxHidden", 1, {
            path: "/",
            expires: d,
          });
        }}
      >
        &nbsp;
      </button>

      <a
        className="app-box__link db clear-fix"
        href={beeline_app[prefix + "url"]}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="app-box__img-out db fl">
          <img src={beeline_app.application_icon} alt={beeline_app.title} />
        </span>
        <span className="app-box__right-content db">
          <span className="app-box__title db fs15">{beeline_app.title}</span>
          <span className="app-box__rate-out db">
            <span className="app-box__rate ver-middle-box">
              {drawStarsHook(beeline_app[prefix + "rating"])}
            </span>
            <span className="app-box__rate-number ver-top-box fs11">
              {beeline_app[prefix + "rating"]}
            </span>
          </span>
          <span className="app-box__field db fs11">
            {trans(props.trans, "app.box." + platform + ".get.title")}
          </span>
        </span>
        <span className="app-box__txt ver-top-box fs17 fr">
          {trans(props.trans, "app.box.view")}
        </span>
      </a>
    </div>
  );
};

export default withCookies(AppBox);
